export type AnnouncementsTranslation = {
  button: {
    label: string;
  };
  coachmark: {
    button: {
      close: string;
      next: string;
      skip: string;
    };
    progress: string;
  };
  items: {
    contactsMenuItemInactiveConflictFix: Feature;
    customersIndividualDistinguishingLabel: Feature;
    dashboardProcesses: Feature;
    dashboardQuickActions: Feature;
    dashboardTasks: Feature;
    emailsCopyRecipients: Feature;
    emailsProcessMatch: Feature;
    tasksFullTextSearch: Feature;
    tasksMenuItemWatchersAccess: Feature;
    topBarAnnouncements: Feature;
    topBarFeedback: Feature;
  };
  panel: {
    close: string;
    empty: string;
    preview: string;
    subtitle: string;
    title: string;
    unavailable: string;
  };
  status: {
    new: string;
    seen: string;
  };
};

type Feature = { description: string; title: string };

export const announcementsTranslation: AnnouncementsTranslation = {
  button: {
    label: 'Nowości',
  },
  coachmark: {
    button: {
      close: 'Rozumiem',
      next: 'Dalej',
      skip: 'Pomiń',
    },
    progress: '{{current}} z {{total}}',
  },
  items: {
    contactsMenuItemInactiveConflictFix: {
      description:
        'Naprawiliśmy konflikt przy dodawaniu danych kontaktowych do nowego kontaktu, gdy ta sama dana jest już użyta w innym, nieaktywnym wpisie. Nadal nie można użyć tej samej danej kontaktowej w dwóch aktywnych kontaktach.',
      title: 'Poprawka dodawania danych kontaktowych',
    },
    customersIndividualDistinguishingLabel: {
      description:
        'Dodaliśmy pole „Wyróżnik”, które pomaga rozróżnić klientów indywidualnych o tej samej nazwie. Wyświetlane jest w nawiasie, obok nazwy klienta. Wyróżnik można dodać i zmienić przy edycji klienta',
      title: 'Nowe pole: Wyróżnik',
    },
    dashboardProcesses: {
      description:
        'Tutaj szybciej wychwycisz procesy, które wymagają reakcji i możesz od razu przejść do szczegółów.',
      title: 'Procesy wymagające uwagi',
    },
    dashboardQuickActions: {
      description:
        'Na górze dashboardu zebraliśmy skróty do najczęstszych akcji, żebyś mógł szybciej rozpocząć pracę.',
      title: 'Szybkie akcje na start',
    },
    dashboardTasks: {
      description:
        'Ten blok pokazuje bieżące zadania przypisane do Ciebie i zespołu bez przechodzenia do osobnego widoku.',
      title: 'Zadania pod ręką',
    },
    emailsCopyRecipients: {
      description:
        'Adresy z listy odbiorców oraz kopii CC możesz teraz łatwo skopiować, kliknięciem ikony obok wybranego adresu.',
      title: 'Szybsze kopiowanie adresów email',
    },
    emailsProcessMatch: {
      description:
        'Przy tworzeniu procesu z wątku email system automatycznie wyszukuje dopasowania klientów, kontaktów i opiekunów. Wyniki wyświetlają się jako karty do wyboru — wystarczy kliknąć odpowiednią, aby uzupełnić dane procesu.',
      title: 'Dopasowania przy tworzeniu procesu',
    },
    tasksFullTextSearch: {
      description: 'Zadania można wyszukiwać po tytule i treści opisu',
      title: 'Usprawnienie wyszukiwania',
    },
    tasksMenuItemWatchersAccess: {
      description:
        'Zaktualizowaliśmy dostęp do zadań prywatnych. Od teraz osoby ustawione jako obserwatorzy mogą wyszukiwać i przeglądać takie zadania.',
      title: 'Dostęp do zadań dla obserwatorów',
    },
    topBarAnnouncements: {
      description:
        'W tym miejscu otworzysz listę najnowszych zmian i wrócisz do opisów funkcji, kiedy będziesz ich potrzebować.',
      title: 'Centrum nowości',
    },
    topBarFeedback: {
      description:
        'Przycisk zgłoszenia błędu jest teraz stale dostępny w top barze, więc możesz szybko przekazać problem lub sugestię.',
      title: 'Szybkie zgłaszanie uwag',
    },
  },
  panel: {
    close: 'Zamknij',
    empty: 'Na tym ekranie nie ma teraz aktywnych opisów.',
    preview: 'Pokaż opis',
    subtitle: 'Krótki przegląd zmian i najważniejszych elementów bieżącego widoku.',
    title: 'Nowości w aplikacji',
    unavailable: 'Niedostępne na tym ekranie',
  },
  status: {
    new: 'Nowe',
    seen: 'Widziane',
  },
};
